import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminRole } from '@/hooks/useAdminRole';
import { consolePathForRole, isStaffRole } from '@/lib/admin/roles';

/** /admin 入口：依 get_admin_role() 分流至对应控制台 */
export default function AdminHubPage() {
  const { role, loading } = useAdminRole();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!role || !isStaffRole(role)) return;
    navigate(consolePathForRole(role), { replace: true });
  }, [role, loading, navigate]);

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center text-sm text-secondary-400">验证权限中…</div>;
  }

  if (!role || !isStaffRole(role)) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-3 px-4">
        <i className="ri-lock-2-line text-3xl text-secondary-300" />
        <p className="text-sm text-foreground-600">此页仅限管理员</p>
        <a href="/" className="text-xs text-primary-600">返回工作台</a>
      </div>
    );
  }

  return <div className="min-h-screen flex items-center justify-center text-sm text-secondary-400">正在进入后台…</div>;
}
